/*
 * Collapses a block of copy to N lines behind a "Read More" toggle.
 *
 * Replaces the jQuery `moreLines` plugin the legacy theme used (theme.js), which
 * needed jQuery plus FontAwesome for its chevron. Matches its behaviour: clamp to
 * `data-lines` x line-height, toggle labels, 250ms animation, and leave the copy
 * alone entirely when it already fits.
 */
(function () {
  var MORE = 'Read More';
  var LESS = 'Read Less';
  var DURATION = 250;

  function collapsedHeight(el) {
    var lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    var lines = parseInt(el.dataset.lines, 10) || 8;
    return lineHeight * lines;
  }

  function setup(el) {
    var caret = el.parentNode.querySelector('.pr-read-more__caret');
    var button = el.parentNode.querySelector('.pr-read-more');
    if (!button) return;

    var max = collapsedHeight(el);
    // Already short enough: no toggle, no clamp.
    if (el.scrollHeight <= max + 1) {
      button.hidden = true;
      el.style.maxHeight = '';
      return;
    }

    button.hidden = false;
    el.style.maxHeight = max + 'px';
    el.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      el.style.transition = 'max-height ' + DURATION + 'ms ease';
      el.style.maxHeight = expanded ? max + 'px' : el.scrollHeight + 'px';
      button.setAttribute('aria-expanded', String(!expanded));
      button.classList.toggle('is-open', !expanded);
      if (caret) caret.classList.toggle('is-open', !expanded);
      button.firstChild.nodeValue = expanded ? MORE : LESS;
    });

    // Once open, drop the fixed height so the block reflows with the viewport.
    el.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'max-height') return;
      if (button.getAttribute('aria-expanded') === 'true') el.style.maxHeight = 'none';
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pr-read-more]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
